<template>
  <section class="journey-nine-section section">
    <div class="container">
      <div class="row justify-content-between g-4">
        <div class="col-lg-4">
          <div class="section-heading section-heading-nine journey-heading-nine aos" data-aos="fade-up">														
            <span class="title-badge">Activity</span>
            <h2 class="text-white">It’s Our <span>journey</span></h2>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 d-flex">
          <div class="journey-client-all aos" data-aos="fade-up">
            <div class="journey-counter">
              <h2><span class="counter">644</span> +</h2>
              <p>Active Clients</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 d-flex">
          <div class="journey-client-all aos" data-aos="fade-up">
            <div class="journey-counter">
              <h2><span class="counter">290</span> +</h2>
              <p>Expert Mechanics</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 d-flex">
          <div class="journey-client-all aos" data-aos="fade-up">
            <div class="journey-counter">
              <h2><span class="counter">100</span> +</h2>
              <p>Total Rewards</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 d-flex">
          <div class="journey-client-all aos" data-aos="fade-up">
            <div class="journey-counter">
              <h2><span class="counter">24</span> +</h2>
              <p>Years Reputation</p>
            </div>
          </div>
        </div>
      </div>


    </div>
  </section>

  <!-- Why Choose Us -->
  <section class="choose-nine-section section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-nine aos" data-aos="fade-up">
            <span class="title-badge">Trusted & Quality Services</span>
            <h2>Why Choose <span>Us?</span></h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center g-4 aos" data-aos="fade-up">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 d-flex">
          <div class="reasonable-wrap bg-primary w-100">
            <img src="@/assets/img/icons/choose-icon-3.svg" alt="image">
            <h5>Expert Mechanics</h5>
            <p>Our expertise spans across ensuring that we have the skills insights to deliver results.</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 d-flex">
          <div class="reasonable-wrap bg-secondary w-100">
            <img src="@/assets/img/icons/choose-icon-4.svg" alt="image">
            <h5>Reasonable Price</h5>
            <p>Your satisfaction is our  priority. We listen to needs, provide personalized solutions</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 d-flex">
          <div class="reasonable-wrap bg-dark w-100">
            <img src="@/assets/img/icons/choose-icon-2.svg" alt="image">
            <h5>fast feature</h5>
            <p>Our commitment to a customer-first approach means we go above beyond to ensure</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 d-flex">
          <div class="reasonable-wrap w-100">
            <img src="@/assets/img/icons/choose-icon-1.svg" alt="image">
            <h5 class="text-gray-9">Awarded Workshop</h5>
            <p class="text-default">From upfront pricing and detailed service descriptions to transparent processes</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Why Choose Us? -->

  <!-- our Mechanics -->
  <section class="mechanics-section section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-nine aos" data-aos="fade-up">													
            <span class="title-badge">Our Team</span>
            <h2>Our <span>Mechanics</span></h2>
          </div>
        </div>
      </div>
      <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
            data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
            aria-selected="true">Car Mechanic</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
            data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
            aria-selected="false">Commercial Mechanic</button>
        </li>
      </ul>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <div class="row aos" data-aos="fade-up">
            <div class="col-md-12">
              <div class="owl-carousel provider-nine-slider">
                <Carousel
                  :wrap-around="true"
                  :settings="settings"
                  :breakpoints="breakpoints"
                >
                  <Slide v-for="item in indexninemechanics" :key="item.id">
                    <div class="providerset providerset-nine">
                      <div class="providerset-img ">
                        <router-link to="/service-provider/provider-details">
                          <img :src="require(`@/assets/img/mechanic/${item.image}`)" alt="img">
                        </router-link>
                      </div>
                      <div class="providerset-content">
                        <h6 class="mb-2">{{ item.title }}</h6>
                        <h5><router-link to="/service-provider/provider-details">{{item.name}}</router-link></h5>
                        <div class="provider-rating provider-rating-nine">
                          <div class="rating">
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i><span>({{item.rating}})</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                  <template #addons>
                    <Pagination />
                  </template>
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /our Mechanics -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexninemechanics from "@/assets/json/indexninemechanics.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexninemechanics: indexninemechanics,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>

<style>
.providerset-nine {
  margin-right: 24px;
}
</style>
